import { api } from '../api';

const LS_VISTAS = 'notificacoes.vistas';

export function idNotificacaoUsuario(u) {
  return `u:${u.id}`;
}
export function idNotificacaoConta(a) {
  return `c:${a.id}`;
}
export function idNotificacaoManutencao(a) {
  return `m:${a.id}`;
}

export function getNotificacoesVistas() {
  try { return JSON.parse(localStorage.getItem(LS_VISTAS) || '[]'); } catch { return []; }
}

/** Junta os IDs recém-vistos aos que já estavam lidos, para o badge não voltar. */
export function marcarTodasComoVistas(ids) {
  const merged = [...new Set([...getNotificacoesVistas(), ...ids])];
  localStorage.setItem(LS_VISTAS, JSON.stringify(merged));
  window.dispatchEvent(new Event('notificacoes-atualizadas'));
}

export async function listarIdsNotificacoes() {
  const isAdmin = localStorage.getItem('role') === 'ADMIN';
  const [contas, manutencoes, usuarios] = await Promise.all([
    api.getAvisosContasAPagar(),
    api.getAvisosManutencaoMaquinario(),
    isAdmin ? api.getUsuariosPendentes() : Promise.resolve([]),
  ]);
  return [
    ...(usuarios || []).map(idNotificacaoUsuario),
    ...(contas || []).map(idNotificacaoConta),
    ...(manutencoes || []).map(idNotificacaoManutencao),
  ];
}
